export { default } from './Facility';
export { default as datamap } from './Facility.datamap';
export type { PageData } from './Facility.datamap';
